import { render, staticRenderFns } from "./HandleDetailModal.vue?vue&type=template&id=240bb605&scoped=true"
import script from "./HandleDetailModal.vue?vue&type=script&lang=js"
export * from "./HandleDetailModal.vue?vue&type=script&lang=js"
import style0 from "./HandleDetailModal.vue?vue&type=style&index=0&id=240bb605&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240bb605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240bb605')) {
      api.createRecord('240bb605', component.options)
    } else {
      api.reload('240bb605', component.options)
    }
    module.hot.accept("./HandleDetailModal.vue?vue&type=template&id=240bb605&scoped=true", function () {
      api.rerender('240bb605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/HandleDetailModal.vue"
export default component.exports